class StylistProgramForm extends HTMLElement {
    email_input_el_selector = '#hsp_email_input'
    name_input_el_selector = '#hsp_full_name_input'
    business_input_el_selector = '#hsp_business_name_input'
    abn_input_el_selector = '#hsp_abn_input'
    constructor() {
        super();
        this.form = this.querySelector('form')
        this.submitEl = this.querySelector('.form-actions input[type="submit"');
        this.validationMsg = JSON.parse(this.dataset.validationMsg.replaceAll('=>', ':'));
    }

    connectedCallback() {
        this.addEventListener('submit', this.handleUserRegistration.bind(this))
        this.validation()
    }

    async validation() {
        const nod = await window.waitForMod("nod")
        const formValidation = await window.waitForMod("formValidation")
        if (!nod || !formValidation) {
            console.error("Required modules are not loaded")
            return
        }
        const validationModel = [
            formValidation.buildRequiredNodValidation(this.name_input_el_selector, 'Name'),
            formValidation.buildRequiredNodValidation(this.email_input_el_selector, 'Email'),
            formValidation.buildRequiredNodValidation(this.business_input_el_selector, 'Business'),
            formValidation.buildRequiredNodValidation(this.abn_input_el_selector, 'ABN'),
            {
                selector: this.email_input_el_selector,
                validate: 'email',
                errorMessage: this.validationMsg.email_address
            },
            {
                selector: this.abn_input_el_selector,
                validate: (cb, val) => {
                    const result = formValidation.abn(val)
                    cb(result);
                },
                errorMessage: this.validationMsg.abn,
            },
        ]
        this.formValidator = nod({ submit: this.submitEl });
        this.formValidator.add(validationModel)
        this.submitEl.removeAttribute('disabled');
    }

    async handleUserRegistration(evt) {
        evt.preventDefault()
        this.formValidator.performCheck();
        if (this.formValidator.areAll('valid')) {
            let msg = "Server is currently experiencing a delay. Please try again.",
                icon = "info"

            await window.luxoLoadSwal?.();
            this.loading()
            const serializedFormData = serializeFormData(this.form)
            const res = await api.luxo.createService({ base_url: "https://app.luxoliving.com.au/" }).post(
                'shopify/promotions/homestylistprogram.php',
                JSON.stringify(serializedFormData)
            )
            if (res.success) {
                if (res.data.status === "success") {
                    msg = "Thank you for submitting your details! We will review your information and be in touch within 48 hours to confirm your registration!"
                    icon = "success"
                    if (window.lintrk)
                        window.lintrk('track', { conversion_id: 25293476 });
                }
                else if (res.data.description === "registered") {
                    msg = "You have already registered for the Home Stylist Program. Please check your email for further details."
                    icon = "info"
                }
                else {
                    msg = res.data.message || "An error occurred while processing your request. Please try again later."
                    icon = "error"
                }
                window.swal?.hideLoading()
                this.showMsg(msg, icon)
            }

            setTimeout(() => {
                if (window.swal && window.swal.isLoading()) {
                    window.swal.close()  //taking too long to load
                    this.showMsg(msg, icon)
                }
            }, 15000);
        }
    }

    loading() {
        if (window.swal)
            window.swal.fire({
                allowOutsideClick: false,
                didOpen: () => {
                    window.swal.showLoading();
                },
            })
    }

    showMsg(msg, icon) {
        window.swal && window.swal.fire({
            customClass: {
                container: "home-stylist-swal",
                confirmButtonClass: "home-stylist-swal-confirmBtn",
            },
            confirmButtonColor: "#282829",
            showCloseButton: true,
            width: '469px',
            text: msg,
            icon
        })
    }
}

customElements.define('stylist-program-form', StylistProgramForm);
